<template>
  <div
    class="head-edit"
    @click="$emit('click')"
    :style="
      theme
        ? {
            color: theme.highlightBtnColor,
            backgroundColor: theme.highlightBtnBg
          }
        : {}
    "
  >
    <i v-if="icon" :class="`icon zsicon ${icon}`"></i>
    <span class="txt">{{ txt }}</span>
  </div>
</template>
<script>
export default {
  name: "HeadEdit",
  props: ["icon", "txt"]
};
</script>
<style lang="less" scoped>
.head-edit {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 32px;
  color: var(--zs-user-box-btn-color);
  background-color: var(--zs-aside-bar-pop-apply-admin-bg);
  border-radius: 20px;
  width: fit-content;
  cursor: pointer;
  .icon {
    margin-right: 4px;
    font-size: 16px;
  }
  .txt {
    font-size: 14px;
  }
}
</style>
